import { useQuery } from "@tanstack/react-query";
import { AnalyticsStatsCard } from "components/analytics/display-card";
import { AnalyticsStatsCardPlaceholder } from "components/analytics/placeholder";
import { fetchPendingReviewEntriesForReviewer } from "components/timesheet/dashboard/reviewer-overview/api";
import { timesheetKeys } from "components/timesheet/queries";
import { formatHoursToTime } from "utils/timesheet";
import { calculateTotalHours } from "utils/utils";

export function ReviewerPendingReviewHoursCard() {
  const { data, isLoading } = useQuery({
    queryKey: timesheetKeys.pendingJobReviewHours(),
    queryFn: fetchPendingReviewEntriesForReviewer,
    select: (data) => calculateTotalHours(data, "logged_hours"),
  });

  if (isLoading) return <AnalyticsStatsCardPlaceholder />;
  return (
    <AnalyticsStatsCard
      label="Pending Review Hours"
      value={formatHoursToTime(data)}
    />
  );
}
